import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from 'styles/colors';

const Svg = styled.svg`
  height: 18px;
  width: 18px;
  fill: none;
`;

function SearchIcon({ className }) {
  return (
    <Svg
      viewBox="0 0 18 18"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(1.000000, 1.000000)" strokeWidth="2">
          <path
            d="M13,6 L12,6.00030005 C12.0006,7.67170005 11.421,9.06300005 10.2396,10.2324 L10.2396,10.2323 L10.2324,10.2396 C9.06300005,11.421 7.67170005,12.0006 6.00030005,12 L5.99978005,12 C4.32867005,12.0004 2.92813005,11.4205 1.74249005,10.236 C0.574810047,9.06720005 -0.000189952929,7.67470005 8.8817842e-16,6.00010005 L8.8817842e-16,6 C8.8817842e-16,4.32739005 0.574070047,2.92657005 1.74251005,1.74251005 C2.92657005,0.574070047 4.32739005,8.8817842e-16 6,8.8817842e-16 L6.00010005,8.8817842e-16 C7.67470005,-0.000189952929 9.06720005,0.574810047 10.236,1.74249005 C11.4205,2.92813005 12.0004,4.32868005 12,5.99978005 L13,6 Z"
            stroke={colors.secondary.deepCove}
          ></path>
          <line
            x1="11"
            y1="11"
            x2="16"
            y2="16"
            id="Path"
            strokeLinecap="round"
            stroke={colors.secondary.deepCove}
          ></line>
        </g>
      </g>
    </Svg>
  );
}

SearchIcon.propTypes = {
  className: PropTypes.string,
};

export default SearchIcon;
